export default __webpack_public_path__ + "static/media/NIAS0480.34I-43130_-25795_0.d41d37af.jpg";